// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "v1.0.1-13-gcef112d",
    "hash": "gcef112d",
    "distance": 13,
    "tag": "v1.0.1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.0.1",
        "major": 1,
        "minor": 0,
        "patch": 1,
        "prerelease": [],
        "build": [],
        "version": "1.0.1"
    },
    "suffix": "13-gcef112d",
    "semverString": "1.0.1+13.gcef112d",
    "version": "0.0.0"
};
/* tslint:enable */
